export const SHOW_CONFIRM = 'SHOW_CONFIRM';
export const CLOSE_CONFIRM = 'CLOSE_CONFIRM';
export const VALID_CONFIRM = 'VALID_CONFIRM';
export const CANCEL_CONFIRM = 'CANCEL_CONFIRM';
